import { type I18nLocale, t } from '@ardoq/i18n';
import { showToast, ToastType } from '@ardoq/status-ui';

type CopyDashboardUrlToClipboardArgs = {
  url: string;
  i18nLocale: I18nLocale;
};

export const copyDashboardUrlToClipboard = async ({
  url,
  i18nLocale,
}: CopyDashboardUrlToClipboardArgs): Promise<void> => {
  try {
    await navigator.clipboard.writeText(url);
    showToast(
      t(i18nLocale, 'dashboard:copyUrl.linkCopied', 'Link copied'),
      ToastType.SUCCESS
    );
  } catch {
    showToast(
      t(i18nLocale, 'dashboard:copyUrl.linkCopyFailed', 'Could not copy link'),
      ToastType.ERROR
    );
  }
};
